import { Instance } from 'mobx-state-tree'
import { PageInfoModel, PageInfoModelType } from '.'
import { ChatConnectionModelBase } from './ChatConnectionModel.base'

/* The TypeScript type of an instance of ChatConnectionModel */
export interface ChatConnectionModelType
  extends Instance<typeof ChatConnectionModel.Type> {}

/* A graphql query fragment builders for ChatConnectionModel */
export {
  selectFromChatConnection,
  chatConnectionModelPrimitives,
  ChatConnectionModelSelector
} from './ChatConnectionModel.base'

/**
 * ChatConnectionModel
 */
export const ChatConnectionModel = ChatConnectionModelBase.views(self => ({
  get $pageInfo() {
    return self.pageInfo as PageInfoModelType
  }
})).actions(self => ({
  // This is an auto-generated example action.
  setPageInfo(pageInfo: PageInfoModelType) {
    self.pageInfo = PageInfoModel.create(pageInfo)
  }
}))
